module.exports = __webpack_public_path__ + "images/faixa-app-background.png?e43c77a66f8a132af6c97ed03ef535cf";


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/assets/images/faixa-app-background.png
// module id = 975
// module chunks = 0